import type { PmsDatabaseType } from '../types/pms';

/**
 * PRX-64: what to call the pharmacy's own PMS in UI copy — the global search
 * fallback row ("Not in PHOX — checking <PMS>…") and its "from <PMS> (added
 * to PHOX)" resolution suffix. `'fillware'` reads as "Fillware" (PharmAssist
 * and other Fillware pharmacies); everything else — `'kroll'`, `'nexxsys'`
 * (which follows the Kroll branch everywhere else in the codebase, see
 * `PmsDatabaseType`), and an unresolved `databaseType` (pharmacy store not
 * loaded yet) — reads as "Kroll", the long-standing GreenShield-first default.
 */
export function pmsDisplayName(databaseType: PmsDatabaseType | null | undefined): string {
  return databaseType === 'fillware' ? 'Fillware' : 'Kroll';
}
